module.exports = __webpack_public_path__ + "static/media/plus.c9471b60.svg";